"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.list.title': 'Sesje Onboardingu',
    'onboarding.list.empty': 'Nie znaleziono sesji onboardingu',
    'onboarding.list.description': 'Zarządzaj procesami onboardingu dla członków Twojego zespołu.',
    'onboarding.list.records': 'Rekordy Onboardingu',
};
